import { Navigate } from 'react-router-dom';
import { useActiveCatalog } from '../../hooks/useActiveCatalog';
import { Spinner } from '../ui/Spinner';
import { darkTheme, FONT } from '../../theme/tokens';

const t = darkTheme;

/**
 * `/catalog` / `/entities` (and the retired `/table` bookmark) land here and
 * redirect to the active catalog's workspace — the entities view, the default
 * canvas section. Works before a specific catalog id is known.
 */
export function CatalogRedirect() {
  const { active, isLoading } = useActiveCatalog();

  if (isLoading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner size={28} />
      </div>
    );
  }

  if (!active) {
    return (
      <div style={{ padding: '28px 32px', fontFamily: FONT, color: t.text2 }}>
        <h1 style={{ color: t.text, fontSize: 22, marginBottom: 12 }}>Catalog</h1>
        <p>Upload a catalog to get started.</p>
      </div>
    );
  }

  return <Navigate to={`/catalogs/${active.id}/entities`} replace />;
}
